/** Helpers for dealing with the State / Counties dataset. */

export interface Location {
  state_fips_code: string;
  full_fips_code?: string;
  population: number;
  state_code: string;
  state: string;
}

/** Aggregations supported by the Explore chart. */
export const AGGREGATED_LOCATIONS: Location[] = [
  {
    state_fips_code: '00',
    full_fips_code: '00001',
    state: 'USA',
    population: 331486822,
    state_code: 'USA',
  },
  {
    state_fips_code: '00',
    full_fips_code: '00002',
    state: 'Native American Majority Counties',
    population: 314704,
    state_code: 'NAMC',
  },
];
